import { IVector3 } from '@easytwin/runtime';
import { create } from 'zustand';

export type DigitCopyData = {
  config: {
    position?: IVector3;
    points?: unknown[];
  };
  customAttribute?: Record<string, unknown>;
};

interface DigitCopyStoreProps {
  copiedData: DigitCopyData[] | undefined;
  setCopiedData: (data: DigitCopyData[]) => void;
}

export const useDigitCopyStore = create<DigitCopyStoreProps>((set) => ({
  copiedData: undefined,
  setCopiedData: (data) => {
    set({ copiedData: data });
  },
}));
